module.exports = {
    sanity: {
      projectId: process.env.GATSBY_SANITY_PROJECT_ID || 'f901zpue',
      dataset: process.env.GATSBY_SANITY_DATASET || 'production',
      token: 'skVBvXjSqcy6AFqdzUSKMJRle4BttyJGJcAnt8TYeFvUusQf8AUaUgx1SMEoLb9zZlBPLVDaSD1TxpHLFcT6pNLV6t6NLHh374EKsz7ld9YcnnUIUeSUCgUsKxNrYHIbVfG0IiuOww24Ww98uBDFOrJLiLGTNNRQztTtfUDRJWwZdYjYYNZs'
    }
  }